export const protocol_questions = {
  edit: {
    history: {
      title: "Historique des modifications du protocole",
      changed_by: "Modifié par",
      changed_at: "Modifié le",
    },
    viewing_local_changes: "Vous visualisez les modifications locales.",
    viewing_live_version: "Vous visualisez la version en direct.",
    clear_local_changes: "Effacer les modifications locales",
    other_protocol_questions_linked_to_the_requirement: "Autres questions de protocole liées à cette exigence",
    no_other_protocol_questions_linked_to_the_requirement:
      "Aucune autre question de protocole n'est liée à cette exigence",
    interlink_questions: "Interlier les questions",
    save_links: "Enregistrer les liens",
  },
  back_to_protocol_question_edit: "Retour à la modification de la question de protocole",
  link: {
    protocol_questions: {
      disabled_link_reason: "Vous devez sélectionner au moins une question de protocole à lier.",
      page_title: "Lier les questions de protocole connexes",
      page_description:
        "Connectez les questions de protocole connexes pour permettre le partage de données entre elles pendant les évaluations. Les questions liées vous permettent de copier les réponses d'une question à une autre.",
      linked_items_title: "Cette question de protocole est déjà liée à :",
    },
    requirements: {
      page_title: "Ici vous pouvez sélectionner et lier des exigences à cette question de protocole.",
      page_description: "Lier les exigences à la question de protocole",
    },
  },
} as const;
